import { Box, Heading, Text } from "@chakra-ui/react";

import { useCreateModal, InitialUseCreateModalType } from "../ModalsProvider";
import useGlobalState from "hooks/useGlobalState";
import CustomLink from "components/Chakra/CustomLink";
import { sendINLeadConversion } from "helpers/conversions";

const InfoINContactModal: React.FC = () => {
  const { user } = useGlobalState();

  return (
    <Box textAlign="center">
      <Heading variant="h2" textAlign="center" mb="16px">
        Děkujeme, <br />
        ozveme se vám na email
      </Heading>
      {user?.email && <Text align="center">{user.email}</Text>}
      <Text
        variant="medium"
        p="16px 26px"
        my="40px"
        backgroundColor="ud-primary-200"
        borderRadius="6px"
      >
        Mezitím můžete mrknout, jak vám{" "}
        <Text as="span" variant="medium" color="ud-primary" fontWeight="bold">
          Ideální nájemce
        </Text>{" "}
        ušetří čas, peníze i starosti.
      </Text>
      <CustomLink
        target="_blank"
        variant="button_outline"
        href="https://idealninajemce.cz/"
        onClick={() => sendINLeadConversion("offer_create")}
        w={{ base: "100%", md: "fit-content" }}
      >
        Více o výhodách služby
      </CustomLink>
    </Box>
  );
};

export const useInfoINContactModal: InitialUseCreateModalType = () =>
  useCreateModal("infoInContactModal", InfoINContactModal, null, null, {
    size: "md",
    variant: "primary",
  });
